import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  label: string;
  /** Destino del botón. Por defecto baja a la oferta de 14.99. */
  href?: string;
  showNote?: boolean;
  align?: 'start' | 'center';
  tone?: 'rust' | 'light';
};
export function CtaButton({
  label,
  href = '#oferta',
  showNote = false,
  align = 'start',
  tone = 'rust'
}: CtaButtonProps) {
  const toneClass = tone === 'rust' ? 'bg-rust text-ink hover:bg-rust-dark hover:text-cream shadow-[4px_4px_0_0_#141210]' : 'bg-cream text-ink hover:bg-kraft-light shadow-[4px_4px_0_0_#d9772e]';
  return <div className={`flex w-full flex-col gap-2.5 sm:w-auto ${align === 'center' ? 'items-center text-center' : 'items-start'}`} data-id="element-37" data-mp="10amx0lw6aau8">
      <a href={href} className={`group inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border-2 border-ink px-4 py-4 font-display text-[13px] font-extrabold uppercase tracking-normal transition-[background-color,color,transform,box-shadow] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] active:translate-x-[2px] active:translate-y-[2px] active:shadow-[2px_2px_0_0_#141210] focus:outline-none focus-visible:ring-4 focus-visible:ring-rust/40 min-[400px]:text-sm sm:w-auto sm:gap-3 sm:px-7 sm:text-lg sm:tracking-wide ${toneClass}`} data-id="element-38" data-mp="vbsfrodusuc8">
        {label}
        <ArrowRightIcon className="hidden h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:block" aria-hidden="true" data-id="element-39" data-mp="3jy8jvuydq6ez" />
      </a>
      {showNote && <p className={`text-xs sm:text-sm ${tone === 'light' ? 'text-kraft-light' : 'text-ink-soft'}`} data-id="element-40" data-mp="3svitzczgnpib">
          Da click en el botón y descubre el valor en tu moneda local
        </p>}
    </div>;
}